import React from 'react';
import Modal from '@components/Modal';
import { useTranslation } from 'next-i18next';

interface iResetModalProps {
  open: boolean;
  onClose: () => void;
  onClick?: () => void;
  modalHeader?: boolean;
}

const ResetModal: React.FC<iResetModalProps> = ({
  open,
  onClick,
  onClose,
  modalHeader = false,
}) => {
  const { t } = useTranslation('common');

  return (
    <Modal opened={open} onClose={onClose} header={modalHeader}>
      <div className="py-1 px-4">
        <div className="items-center text-xl font-medium mt-4">
          <h2>{t('are_you_sure_reset_form')}</h2>
        </div>
        <div className="py-5">{t('progress_lost')}</div>
        <div className="flex items-center space-x-4 py-2 px-4">
          <div className="w-[50%]">
            <div
              className="flex items-center space-x-3 justify-center border px-4 py-2 rounded-3xl font-bold hover:cursor-pointer hover:border-secondary-400 hover:text-blue-400"
              onClick={onClose}
            >
              {t('no')}
            </div>
          </div>
          <div className="w-[50%]">
            <div
              className="flex items-center space-x-3 justify-center border px-4 py-2 rounded-3xl font-bold hover:cursor-pointer text-white bg-primary"
              onClick={onClick}
            >
              {t('yes')}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ResetModal;
